import React from 'react';
import { useQuery } from 'react-query';
import {
  request_underwriter,
  get_underwriters_requests,
} from "services/apiSrv";
import AutoForm from '../forms/AutoForm';
import Loader from '../loader';
import { Modal } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { show_toast } from 'utils/helpers';
import { ModalContext } from 'context/ModalContext';
import { useContext } from 'react';
import { requestUnderwritterForm } from "components/widgets/forms/Request_Underwritter";
import Add_Product_Underwriter from '../forms/setup/Add_Product_Underwriter';


function AddProductUnderwriter(props) {
    const { modalClose } = useContext(ModalContext);

//   async function getUnderwritters() {
//     let resp = await get_underwriters_requests();
//     console.log("underwritters", resp);
//     return resp.underwritters;
//   }

//   const { data, isSuccess, isLoading } = useQuery(
//     "fetch underwriters",
//     getUnderwritters
//   );
// console.log("underwritters data", data)



  // const makeRequest = useMutation(() => {}, {
  //   onSuccess: (data) => {
  //     console.log("THE DATA FROM USE MUTATION", data);
  //     modalClose();
  //     props?.etchUnderwriters();
  //     show_toast("Request made successfully", "success");
  //   },
  //   onError: async (error) => {
  //     let err = await error;
  //     modalClose();
  //   },
  // });

    return (
        <div>
        <Modal
        {...props}
        // show={true}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add an Underwriter</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <Add_Product_Underwriter {...props} />
        </Modal.Body>
      </Modal>
        </div>
    );
}

export default AddProductUnderwriter;